import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';

import { intakeQuestionnaireActions } from '../../../../../store/questionnaires/intake';
import { onboardingQuestionnaireActions } from '../../../../../store/questionnaires/onboarding';
import { toActivities } from '../utils';

import type { RootState } from '../../../../../store';

export default function useYourActivities() {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const { provider } = useSelector((state: RootState) => state.providers);
  const { onboardingQuestionnairesBasicInfo, onboardingQuestionnairesBasicInfoLoading } =
    useSelector((state: RootState) => state.onboardingQuestionnaire);
  const { intakeQuestionnairesBasicInfo, intakeQuestionnairesBasicInfoLoading } = useSelector(
    (state: RootState) => state.intakeQuestionnaire,
  );

  useEffect(() => {
    if (!provider?.id) return;

    dispatch(
      onboardingQuestionnaireActions.getOnboardingQuestionnairesByProviderId({
        providerId: provider.id,
        getAccessTokenSilently,
      }),
    );
    dispatch(
      intakeQuestionnaireActions.getIntakeQuestionnairesByProviderId({
        providerId: provider.id,
        getAccessTokenSilently,
      }),
    );
  }, [dispatch, getAccessTokenSilently, provider?.id]);

  return {
    loading: onboardingQuestionnairesBasicInfoLoading || intakeQuestionnairesBasicInfoLoading,
    activities: toActivities(onboardingQuestionnairesBasicInfo, intakeQuestionnairesBasicInfo),
  };
}
